import {AesRsaEncryptedData} from "@qid/crypto";
import {MetaData} from "@qid/core";
import {Account} from "../../../interface/account.interface";
import {DocumentData} from "../../id";
import {ID} from "../../../models/ID";

export class DocumentAccess extends MetaData {

  grantedToAccount: Account;
  documentOwnerAccount: Account;
  document: ID;
  documentData: DocumentData;
  aesRsaEncryptedData: AesRsaEncryptedData;
  accessRemark?: string;
  apiAccessRemarks?: { time: Date, remark: string }[];

}

